import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { T2Code } from '@lockton-apps/shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class T2CodesService {
  private _model = 't2codes';

  constructor(
    @Inject('BASE_API_URL') private baseUrl: string,
    private http: HttpClient
  ) {}

  private _getUrl() {
    return `${this.baseUrl}/${this._model}`;
  }

  all() {
    return this.http.get<T2Code[]>(this._getUrl());
    // When backend changes cobs uncomment and paste console response to
    // libs/shared/util/constants/src/lib/temp-cob-data.ts
    // .pipe(
    //   tap((t2codes) => {
    //     console.log(
    //       reduce(
    //         t2codes,
    //         (acc, t2code) => {
    //           return [...acc, ...t2code.classOfBusinesses];
    //         },
    //         [] as ClassOfBusiness[]
    //       )
    //     );
    //   })
    // );
  }
}
